import { fetchAuthSession } from "aws-amplify/auth";

async function getAccessToken() {
  const session = await fetchAuthSession();
  const accessToken = session.tokens?.accessToken?.toString();

  if (!accessToken) {
    // fetchAuthSession resolves with no tokens when the user is signed out, so
    // throw rather than letting "undefined" be sent as the auth header.
    throw new Error("No Cognito access token available");
  }

  return accessToken;
}

export default getAccessToken;
